'use client'

import Link from 'next/link'

// Components
import { Icons } from '@/components/shared/icons'
import { MainNav } from '@/components/layout/header/main-nav'
import { MobileNav } from '@/components/layout/header/mobile-nav'
import { GetStartedButton } from '@/components/layout/header/get-started-button'

// Utils
import useScrollDirection from '@/hooks/use-scroll-direction'

// Config
import { siteConfig } from '@/config/site'
import { cn } from '@/lib/utils'

export function SiteHeader() {
  const { scrollDirection, lastScrollY } = useScrollDirection()
  return (
    <header
      className={cn(
        'fixed inset-x-0 z-50 mx-auto w-full bg-black px-3 py-2  backdrop-blur transition-all duration-300 ease-in-out dark:border-border dark:bg-white 2xl:max-w-7xl 2xl:rounded-3xl',
        scrollDirection === 'up' || lastScrollY === 0
          ? 'translate-y-0 2xl:mt-3'
          : '-translate-y-full'
      )}
    >
      <div className="flex items-center px-4">
        <MainNav />
        <MobileNav />

        <div className="flex flex-1 items-center justify-between gap-2 md:justify-end">
          <div className="w-full flex-1 md:hidden">
            <Link
              href="/"
              className="mr-2 flex items-center gap-2 text-background"
            >
              <Icons.logo className="size-6" />
              <span className="inline-block font-satoshi text-lg font-bold">
                {siteConfig.name}
              </span>
            </Link>
          </div>

          <div className="">
            <GetStartedButton />
          </div>
        </div>
      </div>
    </header>
  )
}
